import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: 'DB7B5E3B-9E9E-4007-A194-8913ED4B74F3',
  name: 'Draft',
  description:
    'RFI is ready to be created, but not ready to advance through the RFI Tracker',
  priority: 0,
})
const PendingResponses = new StatusEnumItem({
  id: 'CA34F03B-C593-4E5F-9F8B-EF2D498E7A7C',
  name: 'Pending Responses',
  description: 'Each required Discipline submits a response to the RFI',
  priority: 1,
})
const Closed = new StatusEnumItem({
  id: '30D07946-B9F3-4430-802F-5CEF142D7C33',
  name: 'Closed',
  description:
    'All required Disciplines have submitted and closed their response, backup documents are locked to editing',
  priority: 2,
})
const Unlocked = new StatusEnumItem({
  id: 'E7BAA197-BF74-4003-AA46-CB7B413758A9',
  name: 'Unlocked',
  description: 'Backup documents are unlocked and editable',
  priority: 3,
})

export type RFIStatusItem =
  | typeof Draft
  | typeof PendingResponses
  | typeof Closed
  | typeof Unlocked

class RFIStatusEnum extends StatusEnum<
  'RFIStatus',
  RFIStatusItem,
  RFIStatusItem['name'],
  RFIStatusItem['id'],
  RFIStatusItem['priority']
> {
  readonly typename = 'RFIStatus'
  get values() {
    return [this.Draft, this.PendingResponses, this.Closed, this.Unlocked]
  }
  readonly Draft = Draft
  readonly PendingResponses = PendingResponses
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}

export const RFIStatus = new RFIStatusEnum()
